export const suggestionsMap: Map<string, string> = new Map<string, string>([
  ['', ''],
  ['Use a few words, avoid common phrases', 'validation.passwordStrength.suggestions.useAFewWordsAvoidCommonPhrases'],
  [
    'No need for symbols, digits, or uppercase letters',
    'validation.passwordStrength.suggestions.noNeedForSymbolsDigitsOrUppercaseLetters'
  ],
  [
    'Add another word or two. Uncommon words are better.',
    'validation.passwordStrength.suggestions.addAnotherWordOrTwoUncommonWordsAreBetter'
  ],
  [
    'Use a longer keyboard pattern with more turns',
    'validation.passwordStrength.suggestions.useALongerKeyboardPatternWithMoreTurns'
  ],
  ['Avoid repeated words and characters', 'validation.passwordStrength.suggestions.avoidRepeatedWordsAndCharacters'],
  ['Avoid sequences', 'validation.passwordStrength.suggestions.avoidSequences'],
  ['Avoid recent years', 'validation.passwordStrength.suggestions.avoidRecentYears'],
  [
    'Avoid years that are associated with you',
    'validation.passwordStrength.suggestions.avoidYearsThatAreAssociatedWithYou'
  ],
  [
    'Avoid dates and years that are associated with you',
    'validation.passwordStrength.suggestions.avoidDatesAndYearsThatAreAssociatedWithYou'
  ],
  ["Capitalization doesn't help very much", 'validation.passwordStrength.suggestions.capitalizationDoesntHelpVeryMuch'],
  [
    'All-uppercase is almost as easy to guess as all-lowercase',
    'validation.passwordStrength.suggestions.allUppercaseIsAlmostAsEasyToGuessAsAllLowercase'
  ],
  [
    "Reversed words aren't much harder to guess",
    'validation.passwordStrength.suggestions.reversedWordsArentMuchHarderToGuess'
  ],
  [
    "Predictable substitutions like '@' instead of 'a' don't help very much",
    'validation.passwordStrength.suggestions.predictableSubstitutionsLikeAtInsteadOfADontHelpVeryMuch'
  ]
]);
